"use strict";
exports.__esModule = true;
exports.TRANSACTIONS_SIZE = exports.METACHAIN_SHARD = exports.HASH_TRANSACTION = void 0;
exports.HASH_TRANSACTION = {
    version: 2,
    options: 1
};
exports.METACHAIN_SHARD = 4294967295;
exports.TRANSACTIONS_SIZE = 10000;
//# sourceMappingURL=constants.js.map